import { combineReducers } from 'redux';
import endOfDayReducer from './EndOfDay/reducer';
import OrderReportsReducer from './OrdersReport/reducer';

export default combineReducers({
  endOfDay: endOfDayReducer,
  orderReports: OrderReportsReducer,
});
